// extracted by mini-css-extract-plugin
module.exports = {"navIcon":"u01Ni","rc-tabs-bar":"un6tn","rc-tabs-tab":"cMR81","rc-tabs-tab-active":"_8k1PS","terms":"f41bS","orderHistory-navigation":"_7gT8+","content":"HVYfL","footer":"K-uQ8"};